import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=c50b23fe&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c50b23fe')) {
      api.createRecord('c50b23fe', component.options)
    } else {
      api.reload('c50b23fe', component.options)
    }
    module.hot.accept("./ItemList.vue?vue&type=template&id=c50b23fe&", function () {
      api.rerender('c50b23fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemList.vue"
export default component.exports